import { mergeOptions, obtenerAnioMes } from '@/constantes/helpers'
import firebase from '@/firebase'
import { FS_COLLECTIONS } from '@/firebase'
const db = firebase.firestore()

var cargarCitas = null

const store = {
  state: {
    listaCitas: {}
  },
  getters: {
    listaCitas: state => {
      return state.listaCitas
    }
  },
  mutations: {
    ASIGNA_CATALOGO_CITAS(state, listaCitas) {
      state.listaCitas = listaCitas
    }
  },
  actions: {
    // TODO: Generar Agenda por mes o por año para evitar saturación del Documento
    async agregarAgenda({ getters }, payload) {

      const sucursalActual = getters.usuario.sucursal_actual

      const { cita, fecha } = payload
      const agenda = {
        [cita.Id]: cita,
      }

      return await db.collection(FS_COLLECTIONS.SUCURSALES)
        .doc(sucursalActual).collection(FS_COLLECTIONS.AGENDA_NUEVA)
        .doc(fecha).set(agenda, mergeOptions)

    },
    async removerAgenda({ getters }, payload) {

      const { idCita, fecha } = payload

      const remove = {
        [idCita]: firebase.firestore.FieldValue.delete(),
      }
      console.log("Id cita remover ", idCita)
      const sucursalActual = getters.usuario.sucursal_actual

      return await db.collection(FS_COLLECTIONS.SUCURSALES).doc(sucursalActual)
        .collection(FS_COLLECTIONS.AGENDA_NUEVA).doc(fecha).update(remove)

    },
    cargarCitas({ commit, getters }, fecha) {

      const sucursalActual = getters.usuario.sucursal_actual
      console.log("TCL: cargarCitas -> getters.usuario", getters.usuario)
      const docPath = db.collection(FS_COLLECTIONS.SUCURSALES).doc(sucursalActual)
        .collection(FS_COLLECTIONS.AGENDA_NUEVA).doc(fecha)
      console.log("Carga agenda de agenda23", fecha, sucursalActual)

      return new Promise(resolve => {
        docPath.onSnapshot(doc => {
          //console.log('Current data Agenda: ', doc.data())
          let citas = doc.exists ? { dataSource: doc.data() } : { dataSource: {} }
          citas.fecha = fecha
          commit('ASIGNA_CATALOGO_CITAS', citas)
          resolve()
        })
      })

    },


    cargarCitasStatic({ commit, getters }, fecha) {

      const sucursalActual = getters.usuario.sucursal_actual
      console.log("TCL: cargarCitas -> getters.usuario", getters.usuario)
      const docPath = db.collection(FS_COLLECTIONS.SUCURSALES).doc(sucursalActual)
        .collection(FS_COLLECTIONS.AGENDA_NUEVA).doc(fecha)
      console.log("Carga agenda de agenda23", fecha, sucursalActual)

      return new Promise(resolve => {
        docPath.get().then(doc => {
          //console.log('Current data Agenda: ', doc.data())
          let citas = doc.exists ? { dataSource: doc.data() } : { dataSource: {} }
          citas.fecha = fecha
          //commit('ASIGNA_CATALOGO_CITAS', citas)
          resolve(citas)
        })
      })

    },








    cargaSucursalAgenda({ commit }, idSucursal) {
      if (!idSucursal) return
      return new Promise((resolve, reject) => {
        let docPath = db.collection(FS_COLLECTIONS.SUCURSALES).doc(idSucursal)
        docPath.get().then(doc => {
          resolve(doc.data())
        })
      })

    },

    cargaEspaciosAgenda({ commit, getters }) {
      return new Promise((resolve, reject) => {
        var idFranquicia = getters.usuario.id_franquicia
        let docPath = db
          .collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(idFranquicia)
          .collection(FS_COLLECTIONS.CATALOGOS)
          .doc(FS_COLLECTIONS.ESPACIOS);
        docPath.get().then(doc => {
          resolve(doc.data())
        })
      })
    },



    cargaIndicePacientesAgenda({ commit, getters }, recarga = false) {

      return new Promise(resolve => {
        db.collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.PACIENTES_INDICES).get().then(docs => {

            const listaPacientes = {}
            docs.forEach(e => {
              const pacientes = e.data() || {}
              for (const i in pacientes) {
                listaPacientes[i] = {
                  ...pacientes[i],
                  id: i,
                }
              }
            })
            resolve(listaPacientes)
          })
      })
    },


    cargaIndicePropietariosAgenda({ commit, getters }) {
      return new Promise((resolve, reject) => {

        let docPath = db
          .collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.PROPIETARIOS_INDICESV2);

        docPath.get().then(docs => {
          const listaResultado = {}
          docs.forEach(e => {
            const propietarios = e.data() || {}
            for (const i in propietarios) {
              listaResultado[i] = {
                ...propietarios[i],
                id: i,
              }
            }

          })
          resolve(listaResultado)
        })

      })
    },



    cargaIndiceUsuariosAgenda({ commit, getters }) {
      return new Promise((resolve, reject) => {

        let docPath = db
          .collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.INDICES)
          .doc(FS_COLLECTIONS.USUARIOS);

        docPath.get().then(doc => {
          var usuarios = doc.data()
          let indiceSucursales = getters.indiceSucursales
          for (var keyUs in usuarios) {
            let us = usuarios[keyUs]
            us.sucursales = []
            for (var k in indiceSucursales) {
              if (!us.ids_sucursales) {
                continue
              }
              if (us.ids_sucursales.includes(k)) {
                us.sucursales.push(indiceSucursales[k])
              }
            }
          }
          resolve(usuarios)
        })
      })

    },


    guardaIndicesEspeciesAgenda({ commit }, treeData) {
      //console.log('obtenNombresComunes ::')
      return new Promise((resolve, reject) => {
        let nombresComunes = []
        let especiesLista = []
        const razasLista = []

        if (treeData !== undefined) {
          for (let i in treeData.children) {
            let child = treeData.children[i]
            for (let k in child.children) {
              let grandChild = child.children[k]
              for (let m in grandChild.children) {
                //console.log(grandChild.children[m])
                if (Object.keys(grandChild.children[m]).length > 0) {
                  const razas = JSON.parse(JSON.stringify(grandChild.children[m].children || {}))
                  delete grandChild.children[m].children
                  nombresComunes.push(grandChild.children[m])
                  for (const l in razas) {
                    const raza = razas[l]
                    if (Object.keys(raza).length > 4) {
                      razasLista.push(raza)
                    }
                  }
                }
              }
            }
            delete child.children
            especiesLista.push(child)
          }
        }
        //console.log("Razas lista ", razasLista)
        resolve(nombresComunes)

      })
    },




    cargaServiciosSucursalAgenda({ commit }, idSucursal) {
      return new Promise((resolve, reject) => {
        db.collection("Sucursales").doc(idSucursal)
          .collection("Indices").doc("Servicios").get().then((querySnapshot) => {
            let servicios = querySnapshot.data() !== undefined ? querySnapshot.data() : {};
            resolve(servicios);
          });
      })
    },










  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/agenda/agenda.js